import { useEffect, useState } from 'react';

// HostHome and PastSessions both load a list once on mount and want the same
// data/error shape — pulled out here so a third page doesn't re-copy the
// useState/useEffect boilerplate (mirrors what useLiveState does for streams).
// fetchFn must be a stable reference (a module-level export, not an inline
// arrow), since it drives the effect's dependency.
export const useAsync = (fetchFn, errorMessage) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchFn().then(setData).catch(() => setError(errorMessage));
    }, [fetchFn, errorMessage]);

    return { data, error };
};
